<template>
  <div class="diagram-detail">
    <dna-wrapper>
      <!-- 搜索栏 -->
      <dna-search-bar></dna-search-bar>
      <!-- 区块概览 -->
      <dna-info-block></dna-info-block>
      <!-- 各类图表 -->
      <div class="charts">
        <!-- 每日交易 -->
        <div class="section" v-if="tag == 'transactionDaily'">
          <div class="title">{{$t('diagrams.transactionDaily')}}</div>
          <div class="chart">
            <div v-if="noData" class="nodata">{{$t('charts.dataCollecting')}}</div>
            <dna-transaction-daily-chart v-if="!noData" :list="txDailyData"></dna-transaction-daily-chart>
          </div>
          <dna-spin v-if="isLoading"></dna-spin>
        </div>
        <!-- 每日账户增长 -->
        <div class="section" v-if="tag == 'accountGrowth'">
          <div class="title">{{$t('diagrams.accountGrowth')}}</div>
          <div class="chart">
            <div v-if="noData" class="nodata">{{$t('charts.dataCollecting')}}</div>
            <dna-account-growth-daily-chart v-if="!noData" :list="accountGrowthDailyData"></dna-account-growth-daily-chart>
          </div>
          <dna-spin v-if="isLoading"></dna-spin>
        </div>
        <!-- 持币者统计 -->
        <div class="section" v-if="tag == 'holder'">
          <div class="title">{{$t('diagrams.holderStatistics')}}</div>
          <div class="chart">
            <div v-if="noData" class="nodata">{{$t('charts.dataCollecting')}}</div>
            <dna-account-holder-statistic-chart
              v-if="!noData"
              :list="accountHolderDailyData1"
              :list2="accountHolderDailyData2"
            ></dna-account-holder-statistic-chart>
          </div>
          <dna-spin v-if="isLoading"></dna-spin>
        </div>
        <!-- 价格 -->
        <div class="section" v-if="tag == 'price'">
          <div class="title">{{$t('diagrams.averagePrice')}}</div>
          <div class="chart">
            <div v-if="noData" class="nodata">{{$t('charts.dataCollecting')}}</div>
            <dna-average-price-chart v-if="!noData" :list="priceDailyData"></dna-average-price-chart>
          </div>
          <dna-spin v-if="isLoading"></dna-spin>
        </div>
        <!-- 供给 -->
        <div class="section" v-if="tag == 'totalSupply'">
          <div class="title">{{$t('diagrams.totalSupply')}}</div>
          <div class="chart">
            <div v-if="noData" class="nodata">{{$t('charts.dataCollecting')}}</div>
            <dna-total-supply-chart v-if="!noData" :list="supplyDailyData"></dna-total-supply-chart>
          </div>
          <dna-spin v-if="isLoading"></dna-spin>
        </div>
      </div>
    </dna-wrapper>
  </div>
</template>

<script>
import dnaSearchBar from "@/components/SearchBar/SearchBar.vue";
import dnaInfoBlock from "@/components/InfoBlock/InfoBlock.vue";
// 引入各类图表
import dnaTransactionDailyChart from "@/components/Charts/TransactionDailyChart/TransactionDailyChart.vue";
import dnaAccountGrowthDailyChart from "@/components/Charts/AccountGrowthChart/AccountGrowthChart.vue";
import dnaAccountHolderStatisticChart from "@/components/Charts/AccountHolderStatisticChart/AccountHolderStatisticChart.vue";
import dnaAveragePriceChart from "@/components/Charts/AveragePriceChart/AveragePriceChart.vue";
import dnaTotalSupplyChart from "@/components/Charts/TotalSupplyChart/TotalSupplyChart.vue";

import req from "@/req/req.js";
export default {
  data() {
    return {
      noData: true,
      tag: "",
      txDailyData: [],
      accountGrowthDailyData: [],
      accountHolderDailyData1: [],
      accountHolderDailyData2: [],
      priceDailyData: [],
      supplyDailyData: [],
      isLoading: true,
    };
  },
  mounted() {
    // 获取页面参数
    this.tag = this.$route.query.tag;
    this.noData = this.$route.query.nodata || false;
    this.getData(this.tag);
  },
  methods: {
    async getData(tag) {
      if (tag == "transactionDaily") {
        let data = await req.fetchTxStat();
        this.txDailyData = data.tx_nums;
        this.isLoading = false;
      }
      if (tag == "accountGrowth") {
        let data = await req.fetchAccountStat();
        this.accountGrowthDailyData = data.account_nums;
        this.isLoading = false;
      }
      if (tag == "price") {
        let data = await req.fetchPriceStat();
        this.priceDailyData = data.prices;
        this.isLoading = false;
      }
      if (tag == "holder") {
        let data = await req.fetchHolderStat();
        this.accountHolderDailyData1 = data.holder_num;
        let data2 = await req.fetchUnholderStat();
        this.accountHolderDailyData2 = data2.num;
        this.isLoading = false;
      }
      if (tag == "totalSupply") {
        let data = await req.fetchSupplyStat();
        this.supplyDailyData = data.totalsupplys;
        this.isLoading = false;
      }
    },
  },
  components: {
    dnaSearchBar,
    dnaInfoBlock,
    dnaTransactionDailyChart,
    dnaAccountGrowthDailyChart,
    dnaAccountHolderStatisticChart,
    dnaAveragePriceChart,
    dnaTotalSupplyChart,
  },
};
</script>

<style lang="less" scoped>
@import url("./DiagramDetail.less");
</style>